<template>
  <v-select v-bind="$attrs" solo label="Data Validation Mode" :items="items" :value="value" :disabled="isDisabled"
    :hint="disabledHintMessage" persistent-hint @change="$emit('change', $event)">
  </v-select>
</template>
<script>
  import {
    columnDataValidationModeDescriptions,
  } from '../../store/columnDataValidationModes'
  export default {
    props: {
      value: {
        type: String,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      editMode: {
        type: Boolean,
        default: true,
      },
      canConfigureDataValidationMode: {
        type: Boolean,
        default: true,
      },
      implemented: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      items() {
        return Object.keys(columnDataValidationModeDescriptions).map(k => {
          const dictValue = columnDataValidationModeDescriptions[k]
          return {
            value: k,
            text: dictValue.name,
          }
        })
      },
      disabledHintMessage() {
        const showHint = this.editMode && (!this.canConfigureDataValidationMode || !this.implemented)
        if (!showHint) {
          return ''
        }
        if (!this.implemented) {
          return 'Column is not implemented'
        }
        return 'Validation selection mode is disabled for this column'


      },
      isDisabled() {
        return this.disabled || (!this.editMode) || (!this.canConfigureDataValidationMode) || (!this.implemented)
      },
    },
  }

</script>
